export const updateSingleValueBounds = (value: number) => ({
    lower: value,
    upper: value
});
export const updateSingleValueBounds = (value: number) => ({
    lower: value,
    upper: value
});
